const API_BASE = '/api/brand-kits';

export const brandKitsApi = {
  async list() {
    try {
      console.log('Fetching brand kits from:', API_BASE);
      const response = await fetch(API_BASE);
      console.log('Response status:', response.status);
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const result = await response.json();
      console.log('API response:', result);
      return result.data || [];
    } catch (error) {
      console.error('Failed to list brand kits:', error);
      throw error;
    }
  },

  async get(id) {
    try {
      console.log('Fetching brand kit:', id);
      const response = await fetch(`${API_BASE}/${id}`);
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const result = await response.json();
      console.log('Brand kit API response:', result);
      return result.data;
    } catch (error) {
      console.error('Failed to get brand kit:', error);
      throw error;
    }
  },

  async create(brandKitData) {
    try {
      console.log('Creating brand kit with data:', brandKitData);
      const response = await fetch(API_BASE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(brandKitData)
      });
      
      console.log('Create response status:', response.status);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Create error response:', errorText);
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const result = await response.json();
      console.log('Create API response:', result);
      return result.data;
    } catch (error) {
      console.error('Failed to create brand kit:', error);
      throw error;
    }
  },

  async update(id, updates) {
    try {
      console.log('Updating brand kit:', id, 'with:', updates);
      const response = await fetch(`${API_BASE}/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates)
      });
      
      console.log('Update response status:', response.status);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Update error response:', errorText);
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const result = await response.json();
      console.log('Update API response:', result);
      return result.data;
    } catch (error) {
      console.error('Failed to update brand kit:', error);
      throw error;
    }
  },

  async delete(id) {
    try {
      console.log('Deleting brand kit:', id);
      const response = await fetch(`${API_BASE}/${id}`, {
        method: 'DELETE'
      });
      
      console.log('Delete response status:', response.status);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Delete error response:', errorText);
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      return true;
    } catch (error) {
      console.error('Failed to delete brand kit:', error);
      throw error;
    }
  }
};